import { PathPoints } from '@features/view/MarkerLine';
import React, { useCallback } from 'react';

export interface CPRDrawAreaProps {
  dimensions: { width: number; height: number };
  overlayTranslation: [number, number];
  path: PathPoints[];
  index: [number, number];
  linecolor?: string;
  fillcolor?: string;
}

const CPRDrawArea: React.FC<CPRDrawAreaProps> = ({
  dimensions,
  overlayTranslation,
  path,
  index,
  linecolor = 'blue',
  fillcolor = '#FFD700',
}) => {
  const yAtPathIndex = useCallback(
    (rawIndex: number) => {
      if (path.length === 0) return null;
      let idx = Math.max(0, Math.min(path.length - 1, rawIndex));
      const { x, y } = path[idx];
      return y;
    },
    [path],
  );

  const startpoint = yAtPathIndex(index[0]);
  const endpoint = yAtPathIndex(index[1]);
  let polypoints =
    `${-overlayTranslation[0]}, ${startpoint} ${-overlayTranslation[0]}, ${endpoint} `
  polypoints +=
    `${dimensions.width-overlayTranslation[0]}, ${endpoint} ${dimensions.width-overlayTranslation[0]}, ${startpoint} `

  return (
    <>
      {index &&
        index.map((value, i) => {
          const y = yAtPathIndex(value);
          if (y == null) return null;
          return (
            <g key={i} pointerEvents="none">
            <polygon
              key={`guide-poly-${i}`}
              points={polypoints}
              fill={fillcolor}
              fillOpacity={0.1}
              style={{
                cursor: 'default',
                pointerEvents: 'none',
              }}
            />
            <g key={`guide-${i}`} pointerEvents="none">
              <line
                x1={-overlayTranslation[0]}
                y1={y}
                x2={dimensions.width - overlayTranslation[0]}
                y2={y}
                stroke={linecolor}
                strokeWidth={1}
              />
            </g>
            </g>
          );
        })}
    </>
  );
};

export default CPRDrawArea;
